export default "__VITE_ASSET__D3PVuPHG__"